import { useEffect, useRef, useState } from 'react'
import { useAttachedStyleCard } from '../../../api/attachedStyleCard'
import { isMotionCard, modelsFor, motionModelsFor, repinMotionModel, WHERE_GROUPS } from '../motion/motionTool'
import { useAuth } from '../../../context/AuthContext'
import { isStaff } from '../../../utils/roles'
import { createPortal } from 'react-dom'
import { useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useGenerate } from '../../../context/GenerateContext'
import type { Model } from '../../../data/models'
import { useProviders } from '../../../hooks/useProviders'
import { pickerModelsForTrack } from '../utils/musicModelCaps'
import { modelsForAudioRoute } from '../utils/ttsModels'
import { ModelShields } from '../../../components/RestrictionShields'
import SideTooltip from '../../../components/SideTooltip'
import ModelIcon from '../../../components/ModelIcon'

// Tune/sliders-иконка (как у Artlist) — экспорт: reuse в пилюле «Настройки»
// (GenerateInputBar). Пилюля модели показывает ЛОГО нейронки (ModelIcon).
export const IconSliders = () => (
	<svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
		<path d="M14.757 18.5484C14.4186 18.5484 14.1085 18.4638 13.8265 18.2946C13.5496 18.1306 13.3266 17.9075 13.1574 17.6255C12.9882 17.3487 12.9036 17.0411 12.9036 16.7027C12.9036 16.3643 12.9882 16.0567 13.1574 15.7798C13.3266 15.4979 13.5496 15.2748 13.8265 15.1108C14.1085 14.9416 14.4186 14.857 14.757 14.857C15.0954 14.857 15.403 14.9416 15.6799 15.1108C15.9619 15.2748 16.1849 15.4979 16.3489 15.7798C16.5181 16.0567 16.6027 16.3643 16.6027 16.7027C16.6027 17.0411 16.5181 17.3487 16.3489 17.6255C16.1849 17.9075 15.9619 18.1306 15.6799 18.2946C15.403 18.4638 15.0954 18.5484 14.757 18.5484ZM14.757 17.6025C15.0082 17.6025 15.221 17.5153 15.3953 17.341C15.5696 17.1667 15.6568 16.9539 15.6568 16.7027C15.6568 16.4464 15.5696 16.2336 15.3953 16.0644C15.221 15.8901 15.0082 15.8029 14.757 15.8029C14.5058 15.8029 14.293 15.8901 14.1187 16.0644C13.9444 16.2336 13.8572 16.4464 13.8572 16.7027C13.8572 16.9539 13.9444 17.1667 14.1187 17.341C14.293 17.5153 14.5058 17.6025 14.757 17.6025ZM13.5342 16.0798V17.3179H4.86713C4.69794 17.3179 4.55182 17.259 4.42877 17.1411C4.31085 17.018 4.25189 16.8719 4.25189 16.7027C4.25189 16.5284 4.31085 16.3823 4.42877 16.2643C4.55182 16.1413 4.69794 16.0798 4.86713 16.0798H13.5342ZM19.1559 16.0798C19.3149 16.0798 19.4533 16.1413 19.5712 16.2643C19.6891 16.3823 19.7481 16.5284 19.7481 16.7027C19.7481 16.8719 19.6891 17.018 19.5712 17.1411C19.4533 17.259 19.3149 17.3179 19.1559 17.3179H16.0952V16.0798H19.1559ZM9.32758 13.8572C8.9892 13.8572 8.67902 13.7726 8.39703 13.6035C8.12018 13.4343 7.89716 13.2112 7.72797 12.9344C7.5639 12.6524 7.48187 12.3422 7.48187 12.0038C7.48187 11.6655 7.5639 11.3578 7.72797 11.081C7.89716 10.799 8.12018 10.576 8.39703 10.4119C8.67902 10.2427 8.9892 10.1581 9.32758 10.1581C9.66595 10.1581 9.97357 10.2427 10.2504 10.4119C10.5324 10.576 10.7554 10.799 10.9195 11.081C11.0887 11.3578 11.1733 11.6655 11.1733 12.0038C11.1733 12.3422 11.0887 12.6524 10.9195 12.9344C10.7554 13.2112 10.5324 13.4343 10.2504 13.6035C9.97357 13.7726 9.66595 13.8572 9.32758 13.8572ZM9.32758 12.9036C9.58392 12.9036 9.79669 12.8165 9.96588 12.6422C10.1402 12.4678 10.2274 12.2551 10.2274 12.0038C10.2274 11.7475 10.1402 11.5347 9.96588 11.3655C9.79669 11.1912 9.58392 11.1041 9.32758 11.1041C9.07635 11.1041 8.86359 11.1912 8.68927 11.3655C8.51495 11.5347 8.4278 11.7475 8.4278 12.0038C8.4278 12.2551 8.51495 12.4678 8.68927 12.6422C8.86359 12.8165 9.07635 12.9036 9.32758 12.9036ZM4.83636 11.3809H8.00482V12.6191H4.83636C4.68256 12.6191 4.54669 12.5601 4.42877 12.4422C4.31085 12.3243 4.25189 12.1782 4.25189 12.0038C4.25189 11.8295 4.31085 11.6834 4.42877 11.5655C4.54669 11.4424 4.68256 11.3809 4.83636 11.3809ZM19.1252 11.3809C19.2995 11.3809 19.4456 11.4424 19.5635 11.5655C19.6866 11.6834 19.7481 11.8295 19.7481 12.0038C19.7481 12.1782 19.6866 12.3243 19.5635 12.4422C19.4456 12.5601 19.2995 12.6191 19.1252 12.6191H10.5504V11.3809H19.1252ZM14.757 9.1507C14.4186 9.1507 14.1085 9.06866 13.8265 8.9046C13.5496 8.73541 13.3266 8.51239 13.1574 8.23553C12.9882 7.95355 12.9036 7.64337 12.9036 7.30499C12.9036 6.96661 12.9882 6.659 13.1574 6.38214C13.3266 6.10016 13.5496 5.87457 13.8265 5.70538C14.1085 5.53619 14.4186 5.4516 14.757 5.4516C15.0954 5.4516 15.403 5.53619 15.6799 5.70538C15.9619 5.87457 16.1849 6.10016 16.3489 6.38214C16.5181 6.659 16.6027 6.96661 16.6027 7.30499C16.6027 7.64337 16.5181 7.95355 16.3489 8.23553C16.1849 8.51239 15.9619 8.73541 15.6799 8.9046C15.403 9.06866 15.0954 9.1507 14.757 9.1507ZM14.757 8.20477C15.0082 8.20477 15.221 8.11761 15.3953 7.9433C15.5696 7.76385 15.6568 7.54852 15.6568 7.2973C15.6568 7.04608 15.5696 6.83331 15.3953 6.659C15.221 6.48468 15.0082 6.39752 14.757 6.39752C14.5058 6.39752 14.293 6.48468 14.1187 6.659C13.9444 6.83331 13.8572 7.04608 13.8572 7.2973C13.8572 7.54852 13.9444 7.76385 14.1187 7.9433C14.293 8.11761 14.5058 8.20477 14.757 8.20477ZM13.5727 6.68976V7.92792H4.86713C4.69794 7.92792 4.55182 7.86896 4.42877 7.75104C4.31085 7.62799 4.25189 7.47931 4.25189 7.30499C4.25189 7.1358 4.31085 6.99225 4.42877 6.87433C4.55182 6.75128 4.69794 6.68976 4.86713 6.68976H13.5727ZM19.1559 6.68976C19.3149 6.68976 19.4533 6.75128 19.5712 6.87433C19.6891 6.99225 19.7481 7.1358 19.7481 7.30499C19.7481 7.47931 19.6891 7.62799 19.5712 7.75104C19.4533 7.86896 19.3149 7.92792 19.1559 7.92792H15.9875V6.68976H19.1559Z" />
	</svg>
)

function categoryFromPath(pathname: string): string | undefined {
	if (pathname.startsWith('/bots/images')) return 'image'
	if (pathname.startsWith('/bots/video')) return 'video'
	if (pathname.startsWith('/bots/audio')) return 'audio'
	return undefined
}

export default function WidgetModelPicker({ category: categoryProp }: { category?: string } = {}) {
	const { t } = useTranslation()
	const gen = useGenerate()
	const { widgetModels } = useProviders()
	const location = useLocation()
	const [open, setOpen] = useState(false)
	const [dropdownStyle, setDropdownStyle] = useState<React.CSSProperties>({})
	const pillRef = useRef<HTMLButtonElement>(null)
	const dropdownRef = useRef<HTMLDivElement>(null)

	// Категорию задаёт вызывающий или путь раздела /bots — там список
	// принадлежит странице, и переключать его нечем. Где такой привязки нет
	// (студия /generate), тип выбирается ЗДЕСЬ вкладками «Фото/Видео»: рабочая
	// область больше не делится на зоны (решение владельца 2026-08-05), и
	// именно выбранная нейронка решает, что получится.
	const pageCategory = categoryProp ?? categoryFromPath(location.pathname)
	const [tab, setTab] = useState<'image' | 'video' | null>(null)
	const category = pageCategory ?? tab ?? gen.selectedModel?.category
	// Пин трека: операция уходит по провайдеру ТРЕКА — в пикере только его
	// модели (чужая давала Suno «model error»); недоступные версии (9.5) скрыты.
	const trackOpActive = !!gen.sourceTrack && !!gen.audioOperation && gen.audioOperation !== 'generate'
	// На «Озвучке» — только модели озвучки, на других аудио-страницах — без них.
	// «Повторить движение» (13.10, владелец: выбор нейросети — на штатном месте и в штатном виде): список — только
	// нейросети режима, выбор перепривязывает пин карточки, чтобы режим не закрылся (motion/motionTool). Выбор — у
	// стаффа; юзер работает на нейросети пина (тренд — выбор админа, ссылка — Seedance 2.5): пилюля без списка.
	const pin = useAttachedStyleCard()
	const motion = isMotionCard(pin)
	const auth = useAuth()
	const models = motion
		? motionModelsFor(widgetModels, { staff: isStaff(auth.user?.role), pinnedModelId: pin?.targetModelId })
		: pickerModelsForTrack(
				modelsForAudioRoute(widgetModels, location.pathname).filter((m) => m.category === category),
				gen.sourceTrack?.model ?? null,
				trackOpActive,
			)
	// Вкладки — только для пары «фото/видео»: у аудио и презентаций второго
	// берега нет. Открытие списка сбрасывает выбор на категорию текущей
	// модели, иначе прошлый просмотр чужой вкладки выглядел бы как смена
	// инструмента, которой не было.
	const canSwitch = !motion && !pageCategory && (category === 'image' || category === 'video')
	// Выбирать не из чего (режим у юзера или одна нейросеть режима в каталоге): пилюля — только подпись нейросети.
	const fixed = motion && models.length <= 1
	const renderItem = (m: Model) => {
		const active = m.id === gen.selectedModel?.id
		return (
			<SideTooltip key={m.id} text={m.description || undefined} delay={500}>
				<button
					type="button"
					className={`wmp__item${active ? ' wmp__item--active' : ''}`}
					onClick={() => {
						if (motion) repinMotionModel(m)
						gen.setSelectedModel(m)
						setOpen(false)
					}}
				>
					<ModelIcon icon={m.icon} name={m.name} size={20} className="wmp__item-icon" />
					<span className="wmp__item-name">{m.name}</span>
					{/* Сквозные щиты ограничений контента (см. RestrictionShields) */}
					<ModelShields adapter={m.adapter || m.provider} modelId={m.id} size={12} />
				</button>
			</SideTooltip>
		)
	}
	// Сброс — подстройкой при рендере, а не эффектом (react.dev: you might not
	// need an effect): список закрылся — забываем просмотренную вкладку.
	const [prevOpen, setPrevOpen] = useState(open)
	if (prevOpen !== open) {
		setPrevOpen(open)
		if (!open) setTab(null)
	}

	useEffect(() => {
		if (!open || !pillRef.current) return
		const rect = pillRef.current.getBoundingClientRect()
		setDropdownStyle({
			position: 'fixed',
			left: rect.left,
			bottom: window.innerHeight - rect.top + 6,
			minWidth: Math.max(rect.width, 220),
			zIndex: 9999,
		})
	}, [open])

	useEffect(() => {
		if (!open) return
		const recalc = () => {
			if (!pillRef.current) return
			const rect = pillRef.current.getBoundingClientRect()
			setDropdownStyle({
				position: 'fixed',
				left: rect.left,
				bottom: window.innerHeight - rect.top + 6,
				minWidth: Math.max(rect.width, 220),
				zIndex: 9999,
			})
		}
		window.addEventListener('resize', recalc)
		window.addEventListener('scroll', recalc, true)
		return () => {
			window.removeEventListener('resize', recalc)
			window.removeEventListener('scroll', recalc, true)
		}
	}, [open])

	useEffect(() => {
		if (!open || !dropdownRef.current) return
		const activeItem = dropdownRef.current.querySelector('.wmp__item--active') as HTMLElement | null
		activeItem?.scrollIntoView({ block: 'center', behavior: 'instant' })
	}, [open])

	useEffect(() => {
		if (!open) return
		function handle(e: MouseEvent) {
			const target = e.target as Node
			if (pillRef.current?.contains(target) || dropdownRef.current?.contains(target)) return
			setOpen(false)
		}
		document.addEventListener('mousedown', handle)
		return () => document.removeEventListener('mousedown', handle)
	}, [open])

	if (!gen.selectedModel) return null

	// Presentation: модель выбирается автоматически по режиму (edit → Claude,
	// create → Gamma) через PresentationControls. Свой picker не нужен.
	if (category === 'presentation') return null

	const label = gen.selectedModel.shortName || gen.selectedModel.name

	return (
		<div className={`wmp${open ? ' wmp--open' : ''}`}>
			<button
				ref={pillRef}
				type="button"
				className={`wmp__pill${fixed ? ' wmp__pill--fixed' : ''}`}
				onClick={() => {
					if (!fixed) setOpen((v) => !v)
				}}
				aria-label={t('generate.settings.selectModel')}
				aria-disabled={fixed || undefined}
			>
				{/* Лого выбранной нейронки (Artlist: «G Lyria 3 Pro») */}
				<ModelIcon
					icon={gen.selectedModel.icon}
					name={gen.selectedModel.name}
					size={16}
					className="wmp__pill-logo"
				/>
				<span className="wmp__pill-label">{label}</span>
				{!fixed && (
				<svg
					className="wmp__pill-chevron"
					width="10"
					height="10"
					viewBox="0 0 10 10"
					fill="none"
					aria-hidden="true"
				>
					<path
						d="M2 3.5L5 6.5L8 3.5"
						stroke="currentColor"
						strokeWidth="1.5"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</svg>
				)}
			</button>

			{open &&
				(models.length > 0 || canSwitch) &&
				createPortal(
					<div ref={dropdownRef} className="wmp__dropdown" style={dropdownStyle}>
						{canSwitch && (
							<div className="wmp__tabs" role="tablist" aria-label={t('generate.studio.composition')}>
								{(['image', 'video'] as const).map((k) => (
									<button
										key={k}
										type="button"
										role="tab"
										aria-selected={category === k}
										className={`wmp__tab${category === k ? ' wmp__tab--on' : ''}`}
										onClick={() => setTab(k)}
									>
										{t(k === 'image' ? 'generate.studio.photos' : 'generate.studio.videos')}
									</button>
								))}
							</div>
						)}
						<div className="wmp__list">
							{/* «Повторить движение» (19.10): две группы по тому, где окажется аватар, — «Как в ролике» (замена, переделка
							    Seedance) и «Как на фото» (Kling Motion Control). Решение «где» живёт здесь, не в теле виджета. */}
							{motion
								? WHERE_GROUPS.map((g) => {
										const pool = modelsFor(models, g.key)
										if (!pool.length) return null
										return (
											<div key={g.key} className="wmp__group" role="group" aria-label={g.label}>
												<div className="wmp__group-k">{g.label}<small>{g.hint}</small></div>
												{pool.map(renderItem)}
											</div>
										)
									})
								: models.map(renderItem)}
						</div>
					</div>,
					document.body,
				)}
		</div>
	)
}
